import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import InitialCDD from "./InitialCDD";
import OngoingCDD from "./OngoingCDD";

const tabsKey = [
  {
    name: "Initial",
    tabName: "initial",
    value: 1,
  },
  {
    name: "Ongoing",
    tabName: "ongoing",
    value: 2,
  },
];

const CDD = ({ readAccess, writeAccess }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || "initial";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  useEffect(() => {
    navigate(
      `?tab=cdd&childTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={"border-none"}
        >
          {activeTab === 1 ? (
            <InitialCDD readAccess={readAccess} writeAccess={writeAccess} />
          ) : activeTab === 2 ? (
            <OngoingCDD readAccess={readAccess} writeAccess={writeAccess} />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default CDD;
